module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "soil-moisture-main.b84b1d8d.jpg";